import template from './report_leave_taken_settings.html';
import tr from '../../lib/default-translator.js';

class ReportLeaveTakenSettingsViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.show_salary_structure = ko.observable(false);
	};

	close()
	{
		this.dialog.close();
	}

	async save_date_and_refresh()
	{
		let obj = {
			salary_structure: this.show_salary_structure()
		};

		let res = await Grape.fetches.postJSON('/reports/save_leave_taken_report_settings', obj);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully updated report settings. Please reload the reports page to see changes.'), title: tr('Success', 'Success')});
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};
};

class ReportLeaveTakenSettingsPage
{
	constructor (bindings)
	{
		this.viewModel = new ReportLeaveTakenSettingsViewModel(this);
		this.bindings = bindings;
	}

	init()
	{};
};

export default {
	name: 'ReportLeaveTakenSettings',
	dialog_class: ReportLeaveTakenSettingsPage,
	template: template,
	template_filename: 'translation/dialogs/report_leave_taken_settings',
	provider: 'ps'
};
